<template>
    <client-page>

        <sub-visual
        sh="What We Do"
        tabActive="Overview"
        bg="/images/sub/visual/sv4.png">
        </sub-visual>

        <section class="sub-section--first sub-section--last">
            <v-container>

                <h2 class="page-tit">
                    Overview
                </h2>

                <overview
                src="/images/sub/wwd/overview/overview-img1.png"
                icon="/images/sub/wwd/overview/overview-icon1.png"
                iconWidth="67"
                num="01"
                tit="Customer Service">
                    Based on the consultation, we are presenting the optimal way to manufacture the desired product <br class="d-none d-lg-block">
                    by reflecting the customer’s ideas
                </overview>

                <overview
                className="reverse"
                src="/images/sub/wwd/overview/overview-img2.png"
                icon="/images/sub/wwd/overview/overview-icon2.png"
                iconWidth="55"
                num="02"
                tit="Design and Material Selection">
                    It is possible to mass-produce products through a customizing process such as design and material selection <br class="d-none d-lg-block">
                    that understands the product structure characteristics based on the experience of many semiconductor components.
                </overview>

                <overview
                src="/images/sub/wwd/overview/overview-img3.png"
                icon="/images/sub/wwd/overview/overview-icon3.png"
                iconWidth="54"
                num="03"
                tit="Consultation">
                    We have a variety of precision processing facilities to provide high-quality products to our customers.
                </overview>

                <overview
                className="reverse"
                src="/images/sub/wwd/overview/overview-img4.png"
                icon="/images/sub/wwd/overview/overview-icon4.png"
                iconWidth="54"
                num="04"
                tit="Polishing">
                    Through precision abrasive processing, we produce the optimal product desired by our customers. <br>
                    (Polishing process specialized for CMP process)

                </overview>

                <overview
                src="/images/sub/wwd/overview/overview-img5.png"
                icon="/images/sub/wwd/overview/overview-icon5.png"
                iconWidth="54"
                num="05"
                tit="Quality Inspection">
                    We are equipped with the best measuring instruments necessary for quality control, such as 3D measuring instruments, <br class="d-none d-lg-block">
                    precision roughness measuring instruments and microscopes are strictly conducting data analysis and product management through SPC.
                </overview>

                <overview
                className="reverse"
                src="/images/sub/wwd/overview/overview-img6.png"
                icon="/images/sub/wwd/overview/overview-icon6.png"
                iconWidth="55"
                num="06"
                tit="Application Test">
                    After the first verification test using internal and external facilities, the customer's internal test is carried out.
                </overview>

                <overview
                src="/images/sub/wwd/overview/overview-img7.png"
                icon="/images/sub/wwd/overview/overview-icon7.png"
                iconWidth="54"
                num="07"
                tit="Mass Production">
                    We do our best for the quality and delivery time of the products our customers require.
                </overview>

            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import Overview from "@/components/client/en/sub/sub-overview.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        Overview,
    },
};
</script>

<style lang="scss" scoped>
.overwiew-item:not(:last-child){
    margin-bottom: 30px;
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .overwiew-item:not(:last-child){
        margin-bottom: 60px;
    }
}
@media (min-width:1200px){
}

</style>